<i18n>
{
  "fr": {
    "select": "Choisir ce tarif",
    "cancel": "Annuler",
    "total-amount-including-vat": "Montant total TTC",
    "refundable": "Remboursable sous condition",
    "cancellable_penalty": "Annulable avec frais",
    "cancellable_no_penalty": "Annulable sans frais",
    "modificable_penalty": "Modifiable avec frais",
    "modificable_no_penalty": "Modifiable sans frais",
    "title_refundable": "Remboursable : ",
    "no_refundable": "Remboursable : pas communiqué",
    "no_refundable_possible": "Non remboursable",
    "title_cancellable": "Annulation : ",
    "no_cancellable": "Annulation : pas communiqué",
    "title_modificable": "Modifiable : ",
    "no_modificable": "Modifiable : pas communiqué",
    "conditions": "Conditions tarifaires*",
    "conditions-warning": "*: Les conditions tarifaires vous sont données à titre indicatif. Elles peuvent être incomplètes et modifiées sans préavis par la compagnie aérienne."
  },
  "en": {
    "select": "Select",
    "cancel": "Cancel",
    "total-amount-including-vat": "Total mount incl. VAT",
    "refundable": "Conditionally refundable",
    "cancellable_penalty": "cancellable with fee",
    "cancellable_no_penalty": "cancellable without charge",
    "modificable_penalty": "Modifiable with costs",
    "modificable_no_penalty": "Modifiable without charge",
    "title_refundable": "Refundable: ",
    "no_refundable": "Refundable: not communicated",
    "no_refundable_possible": "Not refundable",
    "title_cancellable": "Cancellable: ",
    "no_cancellable": "Cancellable: not communicated",
    "title_modificable": "Modifiable: ",
    "no_modificable": "Modifiable: not communicated",
    "conditions": "Terms and conditions*",
    "conditions-warning": "*: The fare conditions are given as an indication. They may be incomplete and modified without notice by the airline."
  }
}
</i18n>

<template>
  <v-card
    min-width="280px"
    height="100%"
    class="d-flex fill-height flex-column"
  >
    <v-card-title class="pb-1 pt-2">
      {{ itinerary.price.option_type }}
      <div class="identifier-span">
        {{ getIdentifiant(itinerary.identifier) }}
      </div>
    </v-card-title>
    <v-card-text class="align-stretch fill-height flex-grow-1">
      <div class="d-flex fill-height flex-column">
        <DetailsCardPriceIncludes :pp="itinerary.price" />
        <DetailsCardLuggages
          :pp="itinerary.price"
          :price-included-luggage="'NOTUSED'"
        />
        <div class="pt-4">
          <span>{{ $t('conditions') }} :</span><br>
          <div
            v-if="isInit"
            class="pt-2"
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-progress-circular
                  indeterminate
                  width="2"
                  size="15"
                />
              </v-col>
            </v-row>
          </div>
          <div
            v-else
            :id="'scroll-target-' + itinerary.identifier"
            v-scroll.self="onScroll"
            class="custom-scrollbar overflow-y-auto pt-1"
            :style="{maxHeight: heightDefault+'px'}"
          >
            <div
              :id="'scrolled-content-' + itinerary.identifier"
              v-mutate="() => onMutate()"
            >
              <ul v-if="itinerary && itinerary.detail_fare_rules">
                <li
                  v-for="(frule, index) in itinerary.detail_fare_rules"
                  :id="'frule' + index"
                  :key="'frule' + index"
                  class="caption"
                >
                  <v-row no-gutters>
                    <v-col cols="12">
                      {{ $i18n.locale === 'en' ? frule.en : frule.fr }}
                    </v-col>
                  </v-row>
                </li>
              </ul>
            </div>
          </div>
          <v-row
            align="center"
            justify="center"
            :style="{minHeight: '20px'}"
          >
            <v-btn
              v-if="displayButtonScroll"
              :disabled="disabledScrollDown"
              icon
              x-small
              @click="scrolldown"
            >
              <v-icon>
                mdi-menu-down
              </v-icon>
            </v-btn>
            <v-btn
              v-if="displayButtonScroll"
              :disabled="disabledScrollUp"
              icon
              x-small
              @click="scrollup"
            >
              <v-icon>
                mdi-menu-up
              </v-icon>
            </v-btn>
          </v-row>
        </div>
        <div class="conditions-warning">
          {{ $t('conditions-warning') }}
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="7">
              {{ $t('total-amount-including-vat') }}
            </v-col>
            <v-spacer />
            <v-col class="text-right">
              {{ formatPriceWithCode(itinerary.price.total, itinerary.price.currency) }}
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="12 pt-1">
              <v-btn
                class="mb-2"
                color="primary"
                width="100%"
                :disabled="!canSubmit"
                depressed
                @click="submitItinerary"
              >
                {{ $t('select') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import DetailsCardPriceIncludes
  from '@/components/Flight/FlightSearchResults/FlightSearchResultsGroupPrice/DetailsCardComponents/DetailsCardPriceIncludes'
import DetailsCardLuggages
  from '@/components/Flight/FlightSearchResults/FlightSearchResultsGroupPrice/DetailsCardComponents/DetailsCardLuggages'
import globalMixin from '@/mixins/global'

export default {
  name: 'FlightSelectPriceRevalidateCard',
  components: { DetailsCardLuggages, DetailsCardPriceIncludes },
  mixins: [globalMixin],
  props: {
    pp: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    dialog: true,
    isInit: true,
    canSubmit: true,
    itinerary: undefined,
    container: null,
    elem: null,
    heightDefault: 160,
    displayButtonScroll: false,
    disabledScrollUp: true,
    disabledScrollDown: false
  }),
  created () {
    // let isTf = false
    // console.log('priceDetails', this.priceDetails)
    // console.log('groupPrice', this.groupPrice)

    const tmpPP = _.cloneDeep(this.pp)

    const itinerary = _.cloneDeep(this.pp.itinerary)

    // console.log('price card groupPrice : ', _.cloneDeep(this.groupPrice))
    // console.log('price card pp : ', _.cloneDeep(this.pp))
    if (!_.isNil(itinerary)) {
      itinerary.light_request = true

      // console.log('price card itinerary : ', _.cloneDeep(itinerary))
      // console.log('data key_fare_rules: ', data.itinerary.flight_outward.details[0].key_fare_rules, data)
      itinerary.key_fare_rules = itinerary.flight_outward.details[0].key_fare_rules
      itinerary.key_more_info = itinerary.flight_outward.details[0].key_more_info
      itinerary.detail_fare_rules = tmpPP.fare_rules[itinerary.key_fare_rules]
      itinerary.detail_more_info = tmpPP.fare_rules[itinerary.key_more_info]
      // console.log('data  itinerary.key_fare_rules : ', itinerary.key_fare_rules, _.cloneDeep(itinerary))
      this.itinerary = _.cloneDeep(itinerary)

      setTimeout(() => (this.isInit = false), 500)
    }
  },
  methods: {
    ...mapActions({
      updateSelectedItinerary: 'fb/flightFinalDetailsPutAction',
      changeError: 'general/changeError'
    }),
    close () {
      this.$emit('close')
    },
    submitItinerary () {
      // console.log('submitItinerary : ', _.cloneDeep(this.itinerary))
      if (typeof (this.itinerary) !== 'undefined') {
        this.updateSelectedItinerary(this.itinerary)
      } else {
        this.changeError('couple')
      }
    },

    getIdentifiant (id) {
      return _.split(id, '_', 1)[0]
    },

    scrolldown () {
      this.elem = document.getElementById('scrolled-content-' + this.itinerary.identifier)
      this.container = document.getElementById('scroll-target-' + this.itinerary.identifier)
      // console.log('3333333', this.elem, this.container, this.elem.offsetHeight)
      this.container.scrollTop = this.container.scrollTop + 80
      // console.log('scrolldown this.container.scrollTop', this.container.scrollTop, this.elem.clientHeight)
      if (this.container.scrollTop > this.elem.offsetHeight - this.heightDefault) {
        this.disabledScrollDown = true
      }
      this.disabledScrollUp = false
    },
    scrollup () {
      this.elem = document.getElementById('scrolled-content-' + this.itinerary.identifier)
      this.container = document.getElementById('scroll-target-' + this.itinerary.identifier)
      // console.log('3333333', this.elem, this.container, this.elem.offsetHeight)
      this.container.scrollTop = this.container.scrollTop - 80
      // console.log('scrollup this.container.scrollTop', this.container.scrollTop)
      if (this.container.scrollTop <= 0) {
        this.disabledScrollUp = true
      }
      this.disabledScrollDown = false
    },
    onMutate () {
      this.elem = document.getElementById('scrolled-content-' + this.itinerary.identifier)
      // console.log('onMutate this.elem.offsetHeight', _.cloneDeep(this.elem), _.cloneDeep(this.itinerary.identifier))
      this.displayButtonScroll = this.elem.offsetHeight > this.heightDefault
      this.disabledScrollUp = true
      this.disabledScrollDown = false
    },
    onScroll () {
      this.elem = document.getElementById('scrolled-content-' + this.itinerary.identifier)
      this.container = document.getElementById('scroll-target-' + this.itinerary.identifier)
      // console.log('onScroll this.container.scrollTop', this.container.scrollTop)
      if (this.container.scrollTop <= 0) {
        this.disabledScrollUp = true
        this.disabledScrollDown = false
      } else if (this.container.scrollTop > this.elem.offsetHeight - this.heightDefault) {
        this.disabledScrollDown = true
        this.disabledScrollUp = false
      } else {
        this.disabledScrollDown = false
        this.disabledScrollUp = false
      }
    }
  }
}
</script>

<style scoped>

.identifier-span {
  position: absolute;
  right: 7px;
  font-size: 10px;
  color: #7f7f7f;
  opacity: 0.2;
}

.conditions-warning {
  font-size: 70%;
  display: inline-block;
  line-height: 12px;
  margin-top: 7px;
}

</style>
